import {Alert} from "@mui/joy";
import {createFileRoute} from "@tanstack/react-router";

function CompanyPage() {
    return <Alert>under construction</Alert>
}

export const Route = createFileRoute("/_auth/company/$id/")({
    component: CompanyPage,
});
